import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { CorrectionTypeTableMaintainance, AllocationStatus, downloadCorrectionType } from "../../Services/api";
import instance from "../../redux/api";
import { CommonButton } from "../common/commonButton";
import { CommonSelect } from "../common/commonSelect";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TableContainer,
  Tooltip,
  FormLabel,
  TextField,
} from "@mui/material";
import MyComponent from "../EntityTableMaintainance/EntityDetails";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import { toast } from "react-toastify";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { ViewAndEditEntity } from "./ViewAndEditEnitty";
import { AddCorrection } from "./AddCorrection";
import { commonToast } from "../common";
import format from "date-fns/format";

//styles

const AssignBankStatementBar = {
  display: "flex",
  justifyContent: "space-between",
  height: 32,
  fontWeight: "400",
  marginTop: 10,
};
const editEntityUpdate = {
  width: "90px",
  padding: "18px 0px",
  borderRadius: "20px",
  gap: "8px",
}

const bankTransactionAddBtn = {
  background: "#FF5A01",
  marginLeft: "5%",
  color: "white",
  borderRadius: "10px",
  padding: "5px 20px",
};

const bankStatementSearchBar = {
  width: "180px",
  height: "30px",
  padding: "2px 5px 1px 15px",
  borderRadius: "7px",
  border: "1px solid #d2cccc",
  marginTop: "5px"
};

const ResetSubmit = {
  justifyContent: "flex-end",
  paddingTop: "0px",
  marginRight: "12px",
};
const addBankTransactionReset = {
  backgroundColor: "white",
  width: "90px",
  padding: "16px 0px",
  borderRadius: "20px",
  gap: "8px",
  color: "black",
  border: "1px solid black",
};

const EditPageContainerTransactions = {
  padding: "10px",
  cursor: "default",
  width: "100%",
  marginLeft: "-10px",

};
const EditPageContainerTransactionsList = {
  display: "flex",
  justifyContent: "end",
  width: "100%",
  alignItems: "center",
  marginBottom: "10px"
};

const CloseIconStyle = {
  backgroundColor: "#3B3F44",
  color: "#ffff",
  height: "16px",
  width: "16px",
  padding: "7px 8px",
  borderRadius: "32px",
};
const addBankTransactionSubmit = {
  backgroundColor: "#FF5A01",
  width: "90px",
  padding: "17px 0px",
  borderRadius: "13px",
  gap: "8px",
  color: "white",
};
const downloadBtn = {
  background: "#FF5A01",
  marginLeft: "5%",
  color: "white",
  borderRadius: "10px",
  padding: "5px 25px !important",
  whiteSpace: "nowrap"
};

export default function CorrectionTypeContainer() {
  // Selectors
  const toggle = useSelector((state) => state.toggleSideMenu);
  const { userData } = useSelector((state) => state?.user);
  const [rows, setRows] = useState([
    { correction_type: "", correction_description: "", allocation_status: "" },
  ]);
  const [tableRows, setTableRows] = useState([]);
  const [filteredData, setFilteredData] = useState(tableRows);
  const [isApiCallInprogress, setIsApiCallInprogress] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [searchStatus, setSearchStatus] = useState(null);
  const [EntityDialog, setEntityDialog] = useState(false);
  const [editRow, setEditRow] = useState("");
  const [viewMode, setViewMode] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [isCreated, setIsCreated] = useState(true);
  const [editId, setEditId] = useState("");
  const [pageSize, setPageSize] = useState(5);
  const [allocationStatuss, setAllocationStatus] = useState([]);
  const [page, setPage] = useState(0);
  const [isDownloadInProgress, setIsDownloadInProgress] = useState(false);
  const [currentUpdatedFiledsInEditMode, setCurrentUpdatedFiledsInEditMode] =
    useState({});
  const [validationStatus, setValidationStatus] = useState(
    Array(rows.length).fill(true)
  );

  const [selectAll, setSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);

  const [isSearchPerformed, setIsSearchPerformed] = useState(false);
  const [isClearPerformed, setIsClearPerformed] = useState(false);

  const Container = {
    width: toggle?.isOpen ? "calc(100vw - 305px)" : "calc(100vw - 100px)",
    display: "flex",
    flexDirection: "column",
    gap: 8, 
  };

  useEffect(() => {
    if (isClearPerformed) {
      loadData();
      setIsClearPerformed(false);
    }
  }, [isClearPerformed]);

  const handleDialogClose = () => {
    setEntityDialog(false);
    setEditMode(false);
    setViewMode(false);
    if (!editMode && !viewMode) {
      setRows([
        {
          correction_type: "",
          correction_description: "",
          allocation_status: "",
        },
      ]);
      setSelectedRows([false]);
      setValidationStatus([true]);
    }
    else if(editMode){
      setValidationStatus([true]);
      setCurrentUpdatedFiledsInEditMode({});
    }
  };

  // const handleBrokerBranchDropdown = (index, colName, value, reason, event) => {
  //   const updatedRows = [...rows];
  //   if (updatedRows[index]) {
  //     updatedRows[index][colName] = value;
  //     // Edit Mode

  //     if (editMode) {
  //       setCurrentUpdatedFiledsInEditMode({
  //         ...currentUpdatedFiledsInEditMode,
  //         [colName]: value
  //       });
  //     }
  //   // get broker_information
  //   //   instance.get(`${allocationStatus}+${value}`).then((response) => {
  //   //     if (editMode) {
  //   //       updatedRows[index]['broker_information'] = response?.data?.id;
  //   //       setRows(JSON.parse(JSON.stringify(updatedRows)));
  //   //     } else {  // Add Mode
  //   //       updatedRows[index]['broker_information'] = response?.data?.id;
  //   //       setRows(JSON.parse(JSON.stringify(updatedRows)));
  //   //     }
  //   //   })
  //   // .catch((error) => {
  //   //   console.error("Error fetching data:", error);
  //   // });
  //   } else {
  //     console.error("Row at index", index, "is undefined.");
  //   }
  // };

  const clearSearch = () => {
    setSearchText('')
    setSearchStatus(null)
    setFilteredData(tableRows)
    setIsSearchPerformed(false);
    setIsClearPerformed(true);
  }

  /*
  const handleSearch = (e) => {
    const value = searchText;
    let filterData;
    if (value.trim() === "" && !searchStatus) {
      filterData = tableRows;
    } else {
      filterData = tableRows.filter((row) => {
        const textExists = value.trim() !== "" ? row.correction_type.toLocaleLowerCase().includes(value.toLocaleLowerCase()) : 1 
        const StautsMatch = searchStatus ? row.allocation_status.toLocaleLowerCase().includes(searchStatus.toLocaleLowerCase()) : 1 
        return textExists && StautsMatch;
      })
    }
    setFilteredData(filterData)
  };
  */
  const handleCorrectionTypechange = (name, value) => {
    setSearchText(value ?? "");
    if (isSearchPerformed && !value) {
      if (!searchStatus && !value) {
        clearSearch();
      }
    }
  };

  const handleAllocationStatuschange = (name, value) => {
    setSearchStatus(value ?? null);
    if (isSearchPerformed && !value) {
      if (searchText === "" && !value) {
        clearSearch();
      }
    }
  };

  useEffect(() => {
    setFilteredData(tableRows)
  }, [tableRows])

  useEffect(() => {
    instance
      .get(AllocationStatus)
      .then((response) => setAllocationStatus(response.data))
      .catch((error) =>
        console.error("Error fetching dropdown values:", error)
      );
  }, []);
  const handleCheckboxChange = (index, isChecked) => {
    const updatedSelectedRows = [...selectedRows];
    updatedSelectedRows[index] = isChecked;

    // Check the number of selected rows
    const selectedRowCount = updatedSelectedRows.filter(Boolean).length;

    setSelectedRows(updatedSelectedRows);
    setSelectAll(selectedRowCount === rows.length);
  };

  const handleActionButton = (rowData, isEditMode) => {
    const emptyRows = Array.from({ length: rows.length }, () => ({
      correction_type: "",
      correction_description: "",
      allocation_status: "",
    }));
    if (rowData && isEditMode) {
      // Pre-fill the empty row with data for editing
      setRows([{...rowData}]);
      setEditRow(rowData);
      setEditMode(true);
      setEditId(rowData.id);
      setIsCreated(false);
    } else if (rowData && !isEditMode) {
      setRows([rowData]);
      setViewMode(true);
    } else {
      // If no rowDataForEdit is provided, it means we are in add mode
      setRows(emptyRows);
      setIsCreated(true);
      setEntityDialog(true);
    }
    setEntityDialog(true);
    if (rowData) {
      setIsCreated(false);
    } else {
      setIsCreated(true);
    }
  };


  const handleReset = () => {
    const emptyRows = Array.from({ length: rows.length }, () => ({
      correction_type: "", correction_description: "", allocation_status: "",
    }));
    setRows(emptyRows);
    setSelectedRows([]);
    setSelectAll(false)
    setValidationStatus(Array.from({ length: rows.length }, () => (true)))
  };

  const columns = [
    { field: "id", headerName: "ID", flex: 0.3, headerAlign: "center" },
    {
      field: "correction_type",
      headerName: "Correction Reason",
      flex: 1,
      headerAlign: "center",
    },
    {
      field: "correction_description",
      headerName: "Correction Description",
      flex: 1,
      headerAlign: "center",
    },
    {
      field: "allocation_status",
      headerName: "Allocation Status",
      flex: 1,
      headerAlign: "center",
    },
    {
      field: "created_by",
      headerName: "Created By",
      flex: 1,
      headerAlign: "center",
      valueGetter:(params)=>params?.value??"-"
    },
    {
      field: "updated_by",
      headerName: "Last Modified By",
      flex: 1,
      headerAlign: "center",
      valueGetter:(params)=>params?.value??"-"
    },
    ...(userData?.role !== "CC Processor" ? [{
      field: "actions",
      type: "actions",
      headerName: "Actions",
      flex: 0.8,
      cellClassName: "actions",
      getActions: ({ row }) => {
        let actionsList = [];
        if (UserAuthorisation?.["Edit"] === "Y") {
          actionsList.push(
            <GridActionsCellItem
              icon={
                <Tooltip title="Edit">
                  {" "}
                  <EditIcon />{" "}
                </Tooltip>
              }
              label="Edit"
              className="textPrimary"
              onClick={() => handleActionButton(row, true)}
              color="inherit"
            />
          );
        }

        // if (bankTransactions?.['Delete'] === "Y") {
        //   actionsList.push(
        //     <GridActionsCellItem
        //       icon={<Tooltip title="Delete"><DeleteIcon /> </Tooltip>}
        //       label="Delete"
        //       onClick={() => handleDeleteClick(row.id)}
        //       color="inherit"
        //     />
        //   );
        // }

        if (UserAuthorisation?.["View"] === "Y") {
          actionsList.push(
            <GridActionsCellItem
              icon={<VisibilityIcon />}
              label="view"
              className="textPrimary"
              onClick={() => handleActionButton(row, false)}
              color="inherit"
            />
          );
        }

        return actionsList;
      },
    }] : [
      {
        field: "actions",
        type: "actions",
        headerName: "Actions",
        flex: 0.8,
        cellClassName: "actions",
        getActions: ({ row }) => {
          let actionsList = [];
  
          // if (UserAuthorisation?.['View'] === "Y") {
            actionsList.push(
              <GridActionsCellItem
                icon={<VisibilityIcon />}
                label="view"
                className="textPrimary"
                onClick={() => handleActionButton(row, false)}
                color="inherit"
              />
            );
          // }
  
          return actionsList;
        },
      }
    ]),
  ];
  const loadData = async () => {
    try {
      setIsApiCallInprogress(true);
      let queryParams = ``;
      if (isSearchPerformed) {

        if (searchText) {
          queryParams = `${queryParams}&correction_type=${searchText}`;
        }
        if (searchStatus) {
          queryParams = `${queryParams}&allocation_status=${searchStatus}`;
        }
      }
      const resp = await instance.get(`${CorrectionTypeTableMaintainance}?${queryParams}`);
      setIsApiCallInprogress(false);
      if (resp.status === 200) {
        const sortedData = resp.data.sort((a, b) => b.id - a.id);
        setTableRows(sortedData);
      } else {
        setTableRows([]);
      }
    } catch (err) {
      setIsApiCallInprogress(false);
      console.error("err", err);
    }
  };

  const handleSearchCorrectionTypeList = async () => {
    try {
      let queryParams = ``;

      if (searchText) {
        queryParams = `${queryParams}&correction_type=${searchText}`;
      }

      if (searchStatus) {
        queryParams = `${queryParams}&allocation_status=${searchStatus}`;
      }

      setIsApiCallInprogress(true);

      const resp = await instance.get(`${CorrectionTypeTableMaintainance}?${queryParams}`);

      setIsApiCallInprogress(false);
      if (resp.status === 200) {
        const sortedData = resp.data.sort((a, b) => b.id - a.id);
        setTableRows(sortedData);
        setIsSearchPerformed(true);
      } else {
        setTableRows([]);
      }

    } catch (err) {
      setIsApiCallInprogress(false);
      console.log("err", err);
    }
  };

  const isFilterBtnDisable = () => {
    let disabled = true;
    if (searchText !== "" || searchStatus) {
      disabled = false;
    }
    return disabled;
  }
  const UserAuthorisation =
    userData?.user_permissions?.permissions_list["Admin Table Maintenance"];

  useEffect(() => {
    loadData();
  }, []);
  const handleInputChange = (index, colName, value) => {
    const updatedRows = [...rows];
    if (updatedRows[index]) {
      updatedRows[index][colName] = value;
      setRows(updatedRows);
      // Edit Mode
      if (editMode) {
        setCurrentUpdatedFiledsInEditMode({
          ...currentUpdatedFiledsInEditMode,
          [colName]: value,
        });
      }
    } else {
      console.error("Row at index", index, "is undefined.");
    }
  };
  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    const updatedSelectedRows = new Array(rows.length).fill(isChecked);

    setSelectedRows(updatedSelectedRows);
    setSelectAll(isChecked);
  };

  const handleAddRow = () => {
    setRows([
      ...rows,
      {
        correction_type: "",
        correction_description: "",
        allocation_status: "",
      },
    ]);
  };

  useEffect(() => {
    const selectedRowCount = selectedRows.filter(Boolean).length;
    if (selectedRowCount < rows.length) {
      setSelectAll(false)
    }
  }, [rows, selectedRows])


  const handleDeleteRow = () => {
    // Ensure there is at least one row remaining
    if (rows.length <= 1 || selectAll) {
      // Throw an error or show a message indicating that at least one row should remain
      commonToast("error", "At least One Row Should Remain!!");
      return;
    }

    const updatedRows = rows.filter((row, index) => !selectedRows[index]);
    setRows(updatedRows);

    // Clear selected rows and set Select All to false after deletion
    setSelectedRows([]);
    setSelectAll(false);
  };
  const validateRow = (index) => {
    const row = rows[index];
    const fieldValidations = {};

    // Perform your validations here, for example:
    if (!row || !row.correction_type || row.correction_type.trim() === "") {
      fieldValidations.correction_type = "This field is required";
    }
    if (
      !row ||
      !row.correction_description ||
      row.correction_description.trim() === ""
    ) {
      fieldValidations.correction_description = "This field is required";
    }
    if (
      !row ||
      !row.allocation_status ||
      row.allocation_status.trim() === ""
    ) {
      fieldValidations.allocation_status = "This field is required";
    }
    
    // Add more validations for other fields...
    setValidationStatus((prevStatus) => {
      const newStatus = [...prevStatus];
      newStatus[index] = fieldValidations;
      return newStatus;
    });

    return Object.keys(fieldValidations).length === 0;
  };
  const handleSubmit = async () => {
    // Validate each row before submission
   
    const areRowsValid = rows.map((_, index) => validateRow(index)).every((value) => value);

    let editModeObj = {};
    if (!editMode) {
      // Add Mode
    } else {
      editModeObj.id = editRow?.id;
      editModeObj["updated_by"] = userData?.user_name ?? "";

      editModeObj = { ...editModeObj, ...currentUpdatedFiledsInEditMode };
    }
    //const areRowsValid = true;

    if (!areRowsValid) {
      // If any row is invalid, stop the submission and display an error
      commonToast("error", "Please fix validation errors before submitting.");
      return;
    }

    try {
      let response;
      if (editMode) {
        response = await instance.patch(
          CorrectionTypeTableMaintainance + editId + "/",
          editModeObj
        );
        // clear preiously updated stored data
        setCurrentUpdatedFiledsInEditMode({});
      } else {
        // const flattenedRows = rows.flat();
        rows.forEach((item) => {
          item.created_by = userData?.user_name ?? ""
        })
        response = await instance.post(
          CorrectionTypeTableMaintainance,
          rows
        );
      }

      if (response) {
        if (editMode) {
          commonToast("success", "Updated successfully !");
        } else {
          commonToast("success", "Submission successful !");
        }

        // clean up
        cleanupTransactionData();
      }
    } catch (err) {
      commonToast("error", "Submission failed. Please try again.");
    }
  };

  const cleanupTransactionData = () => {
    handleDialogClose();
    loadData();
  };

  const handleEnter = (e) => {
    if (e.code === "Enter") {
      handleSearchCorrectionTypeList();
    }
  };

  const handleDownloadBtnClick = () => {
    setIsDownloadInProgress(true);
    try {
      instance
        .get(`${downloadCorrectionType}`, { responseType: "blob" })
        .then((response) => {
          const url = URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = url;
          const fileName = `CorrectionReason_${format(new Date(), "dd-MM-yyyy")}`
          link.setAttribute("download", `${fileName}.xlsx`);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          setIsDownloadInProgress(false);
          commonToast("success", "Correction Reason data has been downloaded successfully");
        }).catch((err) => {
          console.log(err);
          setIsDownloadInProgress(false);
          commonToast("error", "Correction Reason data could not be downloaded");
        });
    } catch (error) {
      setIsDownloadInProgress(false);
      console.log(error);
      commonToast("error", "Correction Reason data could not be downloaded");
    }
  }
  return (
    <div style={Container}>
      <div style={AssignBankStatementBar}>
        <span style={{ color: "#FF5A01", fontSize: "24px" }}>
          Correction Reason Table
        </span>
        <div style={{ display: "flex", marginRight: "10px" }}>
          {UserAuthorisation?.["Creation"] === "Y" && (
            <>
            <CommonButton
              text="Add"
              handleClick={() => handleActionButton()}
              sx={bankTransactionAddBtn}
              hoverColor="#FF5A01"
            />
            <CommonButton
              text="Export"
              handleClick={handleDownloadBtnClick}
              sx={downloadBtn}
              hoverColor="#FF5A01"
              disabled={isDownloadInProgress}
            />
            </>
          )}
        </div>
      </div>

      <Grid container
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          mb: "10px",
        }}
        xs={12}
      >
        <Grid item display={"flex"} gap={"10px"} mt={"22px"} mr={"10px"} flexDirection={"column"}>
          <FormLabel>Correction Reason</FormLabel>
          <TextField
            value={searchText}
            onChange={(e) =>
              handleCorrectionTypechange("correction_reason", e.target.value)
            }
            size="small"
            placeholder="Enter Correction Reason"
            onKeyUp={(e) => handleEnter(e)}
          />
        </Grid> 
        <Grid item display={"flex"} gap={"10px"} mt={"25px"} mr={"10px"} flexDirection={"column"}>
          <FormLabel>Allocation Status</FormLabel>
          <div onKeyUp={(e) => handleEnter(e)}>
          <CommonSelect
            placeholder="Select Allocation Status"
            value={searchStatus}
            handleChange={(event, value, reason) => handleAllocationStatuschange("allocation_status", value)}
            options={allocationStatuss?.map((option) => option?.allocation_status) || []}
            customStyles={{ width: "230px" }}
          />
          </div>
        </Grid> 
        <Grid item display={"flex"} gap={"10px"} mt={"22px"} >
          <Grid item display={"flex"} gap={"10px"} mt={"25px"} mr={"10px"} flexDirection={"column"}>
            <FormLabel></FormLabel>
            <CommonButton
              text="Search"
              handleClick={handleSearchCorrectionTypeList}
              hoverColor="#EE3F00"
              disabled={isFilterBtnDisable()}
            />  
          </Grid>           
          <Grid item display={"flex"} gap={"10px"} mt={"25px"} mr={"10px"} flexDirection={"column"}>
              <FormLabel></FormLabel>
              <CommonButton
                text="Clear"
                handleClick={clearSearch}
                hoverColor="#EE3F00"
              />
          </Grid> 
        </Grid>
      </Grid>

      <div
        style={{
          height: 'calc(100vh - 230px)',
          position: "relative",
          display: "flex",
          flexDirection: "row-reverse",
        }}
      >
        <DataGrid
          loading={isApiCallInprogress}
          rows={filteredData}
          columns={columns}
          rowCount={filteredData?.length}
          hideFooterPagination
          hideFooter
          // pageSize={pageSize}
          // paginationMode="server"
          // onPageChange={(newPage) => {
          //   setPage(newPage);
          // }}
          // onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          // rowsPerPageOptions={[10, 25, 50, 100]}
          showCellRightBorder={true}
          rowHeight={38}
        />
      </div>

      {/* <MyComponent /> */}

      <Dialog
        open={EntityDialog}
        disableBackdropClick
        disableEscapeKeyDown
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      // PaperProps={{ style: dialogStyle }}
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{ cursor: "default", paddingBottom: "0px" }}
        >
          {viewMode
            ? "View Correction Reason"
            : editMode
              ? "Edit Correction Reason"
              : "Add Correction Reason"}
          <IconButton
            aria-label="close"
            onClick={handleDialogClose}
            style={{ position: "absolute", right: 12, top: 12 }}
          >
            <CloseIcon style={CloseIconStyle} />
          </IconButton>
          <hr style={{ width: "100%" }} />
        </DialogTitle>
        <DialogContent
          sx={{ overflowX: "hidden", padding: "0px 24px 5px 24px" }}
        >
          <div elevation={4} style={EditPageContainerTransactions}>
            {!editMode && !viewMode && (
              <div style={EditPageContainerTransactionsList}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <CommonButton
                    // sx={addBankTransactionAdd}
                    text="Add"
                    handleClick={handleAddRow}
                    icon={<AddIcon style={{ height: "18px" }} />}
                    hoverColor="#FF5A01"
                  />
                  <CommonButton
                    sx={{
                      backgroundColor: selectAll ? "#FF5A01" : "#CCCCCC",
                      color: selectAll ? "white" : "black",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      padding: "17px 10px",
                      borderRadius: "15px",
                      "&:hover": {
                        background: selectAll ? "#FF5A01" : "#CCCCCC",
                      },
                    }}
                    text="Delete"
                    handleClick={handleDeleteRow}
                    disabled={selectedRows.filter(Boolean).length === 0}
                    icon={<DeleteIcon style={{ height: "19px" }} />}
                  />
                </div>
              </div>
            )}
            {isCreated ? (
              <TableContainer style={{ maxHeight: "300px" }}>
                <AddCorrection
                  selectAll={selectAll}
                  handleInputChange={handleInputChange}
                  handleSelectAll={handleSelectAll}
                  rows={rows}
                  // handleBlur={handleBlur}
                  handleCheckboxChange={handleCheckboxChange}
                  validationStatus={validationStatus}
                  selectedRows={selectedRows}
                  allocationStatus={allocationStatuss}
                //   handleBrokerBranchDropdown={handleBrokerBranchDropdown}
                />
              </TableContainer>
            ) : (
              <>
                {rows?.map((row, index) => (
                  <Grid display={"flex"} flexDirection={"column"}>
                    <ViewAndEditEntity
                      row={row}
                      index={index}
                      viewMode={viewMode}
                      validationStatus={validationStatus}
                      editMode={editMode}
                      handleInputChange={handleInputChange}
                      allocationStatus={allocationStatuss}
                    />
                  </Grid>
                ))}
              </>
            )}
          </div>
        </DialogContent>

        <DialogActions style={ResetSubmit}>
          {viewMode ? null : (
            <>
              {isCreated && (
                <CommonButton
                  sx={addBankTransactionReset}
                  text="Reset"
                  handleClick={() => handleReset()}
                  disabled={editMode}
                />
              )}
              {editMode && (
                <CommonButton
                  sx={editEntityUpdate}
                  text="Update"
                  handleClick={handleSubmit}
                  disabled={Object.keys(currentUpdatedFiledsInEditMode)?.length <= 0}
                  hoverColor="#FF5A01"
                />
              )}
              {!editMode && !viewMode && (
                <CommonButton
                  sx={addBankTransactionSubmit}
                  text="Submit"
                  handleClick={handleSubmit}
                  hoverColor="#FF5A01"
                />
              )}
            </>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
}
